import './index.scss'
import Swiper from 'swiper/js/swiper.min.js'

var swiper_title = new Swiper(".section2 .sec2-swiper .title-swiper", {
  speed: 600,
  allowTouchMove: false,
  resizeObserver: true,
  direction: 'horizontal',
  // effect : 'fade',
  // fadeEffect: {
  //   crossFade: true,
  // },
  breakpoints: {
    767: {
      direction: 'vertical',
      // effect : 'slide',
    }
  },
  on: {
    resize: function(){
      this.update(); //窗口变化时，更新Swiper的一些属性，如宽高等
    },
  },
});
var swiper_desc = new Swiper(".section2 .sec2-swiper .desc-swiper", {
  speed:600,
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  }
});

var swiper_img = new Swiper(".section2 .sec2-swiper .img-swiper", {
  speed:600,
  navigation: {
    nextEl: ".section2 .right-contral .swiper-button-next",
    prevEl: ".section2 .right-contral .swiper-button-prev",
  },
  pagination: {
    el: ".section2 .right-contral .swiper-pagination",
    type : 'progressbar',
  },
  on: {
    init: function(swiper){
      let total = this.slides.length > 9 ? this.slides.length : '0'+ this.slides.length
      let current = this.activeIndex+1 > 9 ? this.activeIndex+1 : '0' + (this.activeIndex+1)
      $('.section2 .right-contral .num .total').html(total)
      $('.section2 .right-contral .num .current').html(current)
    },
    slideChangeTransitionStart: function(){
      swiper_title.slideTo(this.activeIndex);
      swiper_desc.slideTo(this.activeIndex);
      let current = this.activeIndex+1 > 9 ? this.activeIndex+1 : '0' + (this.activeIndex+1)
      $('.section2 .right-contral .num .current').html(current)
    },
  },
});

